import React from "react";

export default function TableRow({row = null, onClick, children}) {

    let RowComponent = row || <tr/>;

    if (React.isValidElement(RowComponent)) {
        RowComponent = React.cloneElement(RowComponent, {onClick}, children);
    } else if (RowComponent === null) {
        RowComponent = children;
    } else {
        RowComponent = (
            <RowComponent onClick={onClick}>
                {children}
            </RowComponent>
        );
    }

    return RowComponent;
}
